const endtime = new Date(2021, 6, 3, 10, 38, 27, 0);

export default endtime;
